import React, { useCallback, useEffect } from "react";

import {
  fetchAttendances,
  fetchParticipants,
  fetchTransactions,
  fetchDirections,
} from "@services/api";

import { useAppStore } from "@store/appStateStore";

import Header from "@components/shared/Header";
import Footer from "@components/shared/Footer";

import LoginWindow from "@components/window/login/LoginWindow";
import Tabbar from "@components/main/tabbar/Tabbar";

import "./App.css";
import "@components/shared/control/style/controls.css";
import "@styles/actionColumn.css";

const App = () => {
  const {
    isAuth,
    setParticipants,
    setAttendances,
    setTransactions,
    setDirections,
  } = useAppStore();

  const LoadDate = useCallback(async () => {
    const participants = await fetchParticipants();
    const attendances = await fetchAttendances();
    const transactions = await fetchTransactions();
    const directions = await fetchDirections();

    setParticipants(participants);
    setAttendances(attendances);
    setTransactions(transactions);
    setDirections(directions);
  }, [setParticipants, setAttendances, setTransactions, setDirections]);

  useEffect(() => {
    if (isAuth) {
      LoadDate();
    }
  }, [isAuth, LoadDate]);

  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        {isAuth ? <Tabbar /> : <LoginWindow />}
      </main>
      <Footer />
    </div>
  );
};

export default App;
